module.exports = __webpack_public_path__ + "static-portal/img/banner6.8eb8fec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner6.jpg
// module id = rtdm
// module chunks = 4